export default __webpack_public_path__ + "static/media/nr_madhavamenon_centre.313e2440.svg";